import { apiBasePath } from "../../constants/constants";
import ApiService from "../../utils/api-service";

export function getAllAttendeesApi(data) {
  let apiUrl = `${apiBasePath}/attendees?populateScores=true&paginated=false`;

  if (data?.bootcampId !== undefined && data?.bootcampId !== null) {
    apiUrl += `&bootcampIds=${data?.bootcampId}`;
  }
  if (data?.moduleId !== undefined) {
    apiUrl += `&moduleId=${data?.moduleId}`;
  }
  if (data?.batchId !== undefined) {
    apiUrl += `&batchIds=${data?.batchId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

function addBootcampIdsForBootcampAttendees(data, apiUrl) {
  if (data?.bootcampId !== undefined && data?.bootcampId !== null) {
    apiUrl += `&bootcampIds=${data?.bootcampId}`;
  }
  return apiUrl;
}

function addModuleForBootcampAttendees(data, apiUrl) {
  if (data?.moduleId !== undefined) {
    apiUrl += `&moduleId=${data?.moduleId}`;
  }
  return apiUrl;
}

function addBatchForBootcampAttendees(data, apiUrl) {
  if (data?.batchId !== undefined) {
    apiUrl += `&batchIds=${data?.batchId}`;
  }
  return apiUrl;
}

function addOffsetForBootcampAttendees(data, apiUrl) {
  if (data?.offset !== undefined) {
    apiUrl += `&offset=${data?.offset * 20}`;
  }
  return apiUrl;
}

function addSortByForBootcampAttendees(data, apiUrl) {
  if (data?.sortBy !== undefined && data?.sortBy !== null) {
    apiUrl += `&sortBy=${data?.sortBy}`;
  }
  return apiUrl;
}

function addSortOrderForBootcampAttendees(data, apiUrl) {
  if (data?.sortOrder !== undefined && data?.sortOrder !== null) {
    apiUrl += `&sortOrder=${data?.sortOrder}`;
  }
  return apiUrl;
}

function addAttendeeNameForBootcampAttendees(data, apiUrl) {
  if (data?.attendeeName !== undefined && data?.attendeeName !== "") {
    apiUrl += `&attendeeName=${data?.attendeeName}`;
  }
  return apiUrl;
}

function addAttendeeEmailForBootcampAttendees(data, apiUrl) {
  if (data?.attendeeEmail !== undefined && data?.attendeeEmail !== "") {
    apiUrl += `&attendeeEmail=${data?.attendeeEmail}`;
  }
  return apiUrl;
}

function addMentorNameForBootcampAttendees(data, apiUrl) {
  if (data?.mentorName !== undefined && data?.mentorName !== "") {
    apiUrl += `&mentorName=${data?.mentorName}`;
  }
  return apiUrl;
}

function addMentorEmailForBootcampAttendees(data, apiUrl) {
  if (data?.mentorEmail !== undefined && data?.mentorEmail !== "") {
    apiUrl += `&mentorEmail=${data?.mentorEmail}`;
  }
  return apiUrl;
}

function addStatusForBootcampAttendees(data, apiUrl) {
  if (data?.status) {
    apiUrl += `&status=${data?.status}`;
  }
  return apiUrl;
}

function addExerciseStatusesForBootcampAttendees(data, apiUrl) {
  if (
    data?.exerciseStatuses !== undefined &&
    data?.exerciseStatuses !== null &&
    data?.exerciseStatuses.length > 0
  ) {
    apiUrl += `&exerciseStatuses=${data?.exerciseStatuses}`;
  }
  return apiUrl;
}

function addBatchesForBootcampAttendees(data, apiUrl) {
  if (
    data?.batchIds !== undefined &&
    data?.batchIds !== null &&
    data?.batchIds?.length > 0
  ) {
    apiUrl += `&batchIds=${data?.batchIds}`;
  }
  return apiUrl;
}

function addCompetenciesForBootcampAttendees(data, apiUrl) {
  if (
    data?.competencyIds !== undefined &&
    data?.competencyIds !== null &&
    data?.competencyIds?.length > 0
  ) {
    apiUrl += `&competencyIds=${data?.competencyIds}`;
  }
  return apiUrl;
}

export function getAttendeesApi(data) {
  let apiUrl = `${apiBasePath}/attendees?populateScores=false&max=20`;

  apiUrl = addBootcampIdsForBootcampAttendees(data, apiUrl);
  apiUrl = addModuleForBootcampAttendees(data, apiUrl);
  apiUrl = addBatchForBootcampAttendees(data, apiUrl);
  apiUrl = addOffsetForBootcampAttendees(data, apiUrl);
  apiUrl = addSortByForBootcampAttendees(data, apiUrl);
  apiUrl = addSortOrderForBootcampAttendees(data, apiUrl);
  apiUrl = addAttendeeNameForBootcampAttendees(data, apiUrl);
  apiUrl = addAttendeeEmailForBootcampAttendees(data, apiUrl);
  apiUrl = addMentorNameForBootcampAttendees(data, apiUrl);
  apiUrl = addMentorEmailForBootcampAttendees(data, apiUrl);
  apiUrl = addStatusForBootcampAttendees(data, apiUrl);
  apiUrl = addExerciseStatusesForBootcampAttendees(data, apiUrl);
  apiUrl = addBatchesForBootcampAttendees(data, apiUrl);
  apiUrl = addCompetenciesForBootcampAttendees(data, apiUrl);

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getUsersApi(data) {
  let apiUrl = `${apiBasePath}/users?paginated=false&mentorExists=true`;

  if (data?.competencyId) {
    apiUrl += `&competencyIds=${[data?.competencyId]}`;
  }
  if (data?.designationId) {
    apiUrl += `&designationIds=${data?.designationId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}
export function getUsersForAddAttendeeApi(data) {
  let apiUrl = `${apiBasePath}/users?competencyIds=${[
    data?.competencyId,
  ]}&paginated=false`;
  if (data?.designationId) {
    apiUrl += `&designationIds=${[data?.designationId]}`;
  }
  if (data?.bootcampId) {
    apiUrl += `&notAttendeeInBootcampId=${data?.bootcampId}`;
  }
  if (data?.moduleId) {
    apiUrl += `&notAttendeeInModuleId=${data?.moduleId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function updateAttendeeApi(data) {
  let apiUrl = `${apiBasePath}/attendees`;

  const options = {
    method: "PATCH",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getCompetenciesApi(data) {
  let apiUrl = `${apiBasePath}/competencies`;
  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getDesignationApi(data) {
  let apiUrl = `${apiBasePath}/designations?competencyId=${data?.competencyIds}`;

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function addAttendeeApi(data) {
  let apiUrl = `${apiBasePath}/attendees`;

  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getBatchesApi(data) {
  const { moduleId } = data;
  let apiUrl = `${apiBasePath}/moduleBatches`;
  if (moduleId !== undefined && moduleId !== null) {
    apiUrl += `?moduleId=${moduleId}&paginated=false`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}
export function deleteAttendeeApi(attendeeId) {
  let apiUrl = `${apiBasePath}/attendees/${attendeeId}`;

  const options = {
    method: "DELETE",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getBootcampApi({ bootcampId }) {
  let apiUrl = `${apiBasePath}/bootcamps/${bootcampId}`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getOptionsForCreateAttendeeApi({ bootcampId }) {
  let apiUrl = `${apiBasePath}/utilities/optionsForCreateAttendee?bootcampId=${bootcampId}`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getOptionsForEditAttendeeApi({ bootcampId, moduleId }) {
  let apiUrl = `${apiBasePath}/utilities/optionsForEditAttendee`;
  if (bootcampId) {
    apiUrl += `?bootcampId=${bootcampId}`;
  } else if (moduleId) {
    apiUrl += `?moduleId=${moduleId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getFiltersForAttendeesApi({ bootcampId, moduleId }) {
  let apiUrl = `${apiBasePath}/utilities/filtersForAttendeesListing`;
  if (bootcampId) {
    apiUrl += `?bootcampId=${bootcampId}`;
  } else if (moduleId) {
    apiUrl += `?moduleId=${moduleId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

function addBootcampForModuleAttendees(data, apiUrl) {
  if (data?.bootcampId !== undefined && data?.bootcampId !== null) {
    apiUrl += `&bootcampIds=${data?.bootcampId}`;
  }
  return apiUrl;
}

function addModuleForModuleAttendees(data, apiUrl) {
  if (data?.moduleId !== undefined) {
    apiUrl += `&moduleId=${data?.moduleId}`;
  }
  return apiUrl;
}

function addBatchForModuleAttendees(data, apiUrl) {
  if (data?.batchId !== undefined) {
    apiUrl += `&batchIds=${data?.batchId}`;
  }
  return apiUrl;
}

function addOffsetForModuleAttendees(data, apiUrl) {
  if (data?.offset !== undefined) {
    apiUrl += `&offset=${data?.offset * 20}`;
  }
  return apiUrl;
}

function addSortByForModuleAttendees(data, apiUrl) {
  if (data?.sortBy !== undefined && data?.sortBy !== null) {
    apiUrl += `&sortBy=${data?.sortBy}`;
  }
  return apiUrl;
}

function addSortOrderForModuleAttendees(data, apiUrl) {
  if (data?.sortOrder !== undefined && data?.sortOrder !== null) {
    apiUrl += `&sortOrder=${data?.sortOrder}`;
  }
  return apiUrl;
}

function addAttendeeNameForModuleAttendees(data, apiUrl) {
  if (data?.attendeeName !== undefined && data?.attendeeName !== "") {
    apiUrl += `&attendeeName=${data?.attendeeName}`;
  }
  return apiUrl;
}

function addAttendeeEmailForModuleAttendees(data, apiUrl) {
  if (data?.attendeeEmail !== undefined && data?.attendeeEmail !== "") {
    apiUrl += `&attendeeEmail=${data?.attendeeEmail}`;
  }
  return apiUrl;
}

function addMentorNameForModuleAttendees(data, apiUrl) {
  if (data?.mentorName !== undefined && data?.mentorName !== "") {
    apiUrl += `&mentorName=${data?.mentorName}`;
  }
  return apiUrl;
}

function addMentorEmailForModuleAttendees(data, apiUrl) {
  if (data?.mentorEmail !== undefined && data?.mentorEmail !== "") {
    apiUrl += `&mentorEmail=${data?.mentorEmail}`;
  }
  return apiUrl;
}

function addStatusForModuleAttendees(data, apiUrl) {
  if (data?.status) {
    apiUrl += `&status=${data?.status}`;
  }
  return apiUrl;
}

function addExerciseStatusesForModuleAttendees(data, apiUrl) {
  if (
    data?.exerciseStatuses !== undefined &&
    data?.exerciseStatuses !== null &&
    data?.exerciseStatuses.length > 0
  ) {
    apiUrl += `&exerciseStatuses=${data?.exerciseStatuses}`;
  }
  return apiUrl;
}

function addBatchesForModuleAttendees(data, apiUrl) {
  if (
    data?.batchIds !== undefined &&
    data?.batchIds !== null &&
    data?.batchIds?.length > 0
  ) {
    apiUrl += `&batchIds=${data?.batchIds}`;
  }
  return apiUrl;
}

function addCompetenciesForModuleAttendees(data, apiUrl) {
  if (
    data?.competencyIds !== undefined &&
    data?.competencyIds !== null &&
    data?.competencyIds?.length > 0
  ) {
    apiUrl += `&competencyIds=${data?.competencyIds}`;
  }
  return apiUrl;
}

export function getModuleAttendeesApi(data) {
  let apiUrl = `${apiBasePath}/moduleAttendees?populateScores=true&max=20`;

  apiUrl = addBootcampForModuleAttendees(data, apiUrl);
  apiUrl = addModuleForModuleAttendees(data, apiUrl);
  apiUrl = addBatchForModuleAttendees(data, apiUrl);
  apiUrl = addOffsetForModuleAttendees(data, apiUrl);
  apiUrl = addSortByForModuleAttendees(data, apiUrl);
  apiUrl = addSortOrderForModuleAttendees(data, apiUrl);
  apiUrl = addAttendeeNameForModuleAttendees(data, apiUrl);
  apiUrl = addAttendeeEmailForModuleAttendees(data, apiUrl);
  apiUrl = addMentorNameForModuleAttendees(data, apiUrl);
  apiUrl = addMentorEmailForModuleAttendees(data, apiUrl);
  apiUrl = addStatusForModuleAttendees(data, apiUrl);
  apiUrl = addExerciseStatusesForModuleAttendees(data, apiUrl);
  apiUrl = addBatchesForModuleAttendees(data, apiUrl);
  apiUrl = addCompetenciesForModuleAttendees(data, apiUrl);

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function deleteModuleAttendeeApi(attendeeId) {
  let apiUrl = `${apiBasePath}/moduleAttendees/${attendeeId}`;

  const options = {
    method: "DELETE",
    url: apiUrl,
  };
  return ApiService(options);
}

export function updateModuleAttendeeApi(data) {
  let apiUrl = `${apiBasePath}/moduleAttendees`;

  const options = {
    method: "PATCH",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}
